var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7411 0.244639L16.7916 5.55623C16.9252 5.69717 17 5.88443 17 6.07973V15.4435C17 17.9553 14.9971 20 12.5337 20H4.57002C1.96399 20 0 18.0409 0 15.4435V12.9206C0 12.5038 0.334975 12.1655 0.747713 12.1655C1.16045 12.1655 1.49543 12.5038 1.49543 12.9206V15.4435C1.49543 17.2083 2.78847 18.4899 4.57002 18.4899H12.5337C14.1726 18.4899 15.5046 17.1227 15.5046 15.4435V6.38276L11.6873 2.36887V3.68569C11.6873 4.69647 12.5018 5.51998 13.5027 5.522C13.9154 5.523 14.2494 5.86127 14.2484 6.27907C14.2474 6.69486 13.9134 7.03211 13.5007 7.03211H13.4997C11.6763 7.02809 10.1918 5.52703 10.1918 3.68569V1.5222H4.57002C2.90312 1.5222 1.49543 2.8954 1.49543 4.52129V8.81607C1.49543 9.23286 1.16045 9.57113 0.747713 9.57113C0.334975 9.57113 0 9.23286 0 8.81607V4.52129C0 2.07692 2.0926 0.0120809 4.57002 0.0120809H10.8817C10.8913 0.0111597 10.9 0.00855261 10.9086 0.00599509C10.9188 0.00296268 10.9287 0 10.9395 0C10.9512 0 10.9616 0.0031256 10.972 0.00624198C10.9803 0.00871858 10.9885 0.0111894 10.9974 0.0120809H11.2017C11.4051 0.0120809 11.5995 0.0956408 11.7411 0.244639ZM7.56988 8.52142C7.56988 8.10462 7.90485 7.76636 8.31759 7.76636C8.73033 7.76636 9.0653 8.10462 9.0653 8.52142V10.2339H10.7611C11.1739 10.2339 11.5088 10.5722 11.5088 10.9889C11.5088 11.4057 11.1739 11.744 10.7611 11.744H9.0653V13.4555C9.0653 13.8723 8.73033 14.2105 8.31759 14.2105C7.90485 14.2105 7.56988 13.8723 7.56988 13.4555V11.744H5.87506C5.46232 11.744 5.12735 11.4057 5.12735 10.9889C5.12735 10.5722 5.46232 10.2339 5.87506 10.2339H7.56988V8.52142Z",
    fill: "#FC2B6E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOnIcon);
export default __webpack_public_path__ + "static/media/AddOnIcon.9723e17ebc1d94e5c480ba690ef28142.svg";
export { ForwardRef as ReactComponent };